import "./App.scss";
import Landing from "./components/landing/Landing.js";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./components/Login/Login";
import Forgot from "./components/ForgotPassword/Forgot";
import NewPassword from "./components/ForgotPassword/NewPassword";
import New_Admin_Password from "./components/ForgotPassword/New_Admin_Password.js";
import Success from "./components/ForgotPassword/Success";
import useEagerConnect from "./hooks/useEagerConnect";
import Topccountry from "./components/landing/Dashboard/Topccountry.js";
import ViewDetail from "./components/Allreferrers/ViewDetail.js";
import Createpremiumprojects from "./components/landing/Allpremiumprojects/Createpremiumprojects/Createpremiumprojects.js";
import PreviewProject from "./components/landing/Allpremiumprojects/PreviewProject/PreviewProject.js";
import Bottompage from "./components/landing/Allpremiumprojects/Createpremiumprojects/Bottompage.js";
import Newfooter from "./components/Newfooter/Newfooter.js";

function App() {
  useEagerConnect();
  return (
    <>
      <ToastContainer
        autoClose={5000}
        style={{ fontSize: 12, fontWeight: 300 }}
        theme="dark"
        position="top-center"
      />
      <Router>
        <Switch>
          <Route exact path="/" component={Landing} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/forgot" component={Forgot} />
          <Route exact path="/reset-password" component={NewPassword} />
          <Route exact path="/new-password" component={New_Admin_Password} />
          <Route exact path="/success" component={Success} />
          <Route exact path="/topcountry" component={Topccountry} />
          <Route exact path="/viewDetail" component={ViewDetail} />
          <Route exact path="/createproject" component={Createpremiumprojects} />
          <Route exact path="/preview" component={PreviewProject} />
          <Route exact path="/bottompage" component={Bottompage} />
                 <Route exact path="/newfooter" component={Newfooter} />
        </Switch>
      </Router>
    </>
  );
}

export default App;
